module.exports = __webpack_public_path__ + "static/media/copy.19418c85.svg";